import {
    type FC
} from "react";
import {
    Text as NativeText,
    type TextStyle
} from "react-native";
import type ITextProps from "./type";
import {
    NCoreUIKitTheme
} from "../../core/hooks";

const Text: FC<ITextProps> = ({
    variant = "bodyMediumSize",
    customLocalize,
    color = "mid",
    customColor,
    customTheme,
    children,
    style,
    ...props
}) => {
    const {
        typography,
        colors
    } = NCoreUIKitTheme.useContext(customTheme, customLocalize);

    const getTextColor = () => {
        if(!customColor) {
            return colors.content.text[color];
        }

        const _customColor = customColor as keyof NCoreUIKit.ProjectColorPalette;

        return colors.project[_customColor] ? colors.project[_customColor] : customColor;
    };

    return <NativeText
        {...props}
        style={[
            style,
            {
                ...typography[variant],
                color: getTextColor()
            } as TextStyle
        ]}
    >
        {children}
    </NativeText>;
};
export default Text;
